import { Link, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase";
import "./Sidebar.css";

export default function SidebarMember() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/login");
  };

  return (
    <div className="sidebar">
      <div className="sidebar-header">Member</div>
      <nav className="sidebar-nav">
        <Link to="/member/dashboard">🏠 Dashboard</Link>
        
        <Link to="/member/my-groups">👥 My Groups</Link>
        <Link to="/member/payments">💰 Payments</Link>
        <Link to="/member/alerts">🔔 Alerts</Link>
      </nav>
      <div className="sidebar-footer">
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </div>
  );
}
